import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportPostsComponent } from './import-posts.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: ImportPostsComponent, data: { title: 'Importar Posts desde WordPress' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ImportPostsRoutingModule { }
